import type { PlanType } from '@/scenes/Editor/components/Navbar/components/SignIn/Metsikon/metsikonPlanConfig'

/** Legacy key retained for migration tests; the per-user campaign never reads or writes it. */
export const LIMITED_TIME_OFFER_SHOWN_KEY = 'shownLimitedTimeSuperOffer'

export interface LimitedTimeOfferGate {
  /** Tier the user just checked out on. */
  purchasedPlanType: PlanType
  /** Billing period the user just checked out on. */
  purchasedPeriod: 'month' | 'year'
  userIsPremium?: boolean | null
  userIsSuper?: boolean | null
}

/**
 * The offer is a Premium -> Super upsell shown once, immediately after a
 * *monthly* Premium purchase. Anything else (a Super checkout, a yearly
 * checkout, an existing Super subscriber, a repeat purchase) must not see it:
 * the upsell switches the subscription to a monthly Super price, so offering
 * it to a yearly subscriber would shorten their billing period.
 */
export function shouldShowLimitedTimeOffer({
  purchasedPlanType,
  purchasedPeriod,
  userIsPremium,
  userIsSuper,
}: LimitedTimeOfferGate): boolean {
  if (purchasedPlanType !== 'premium') return false
  if (purchasedPeriod !== 'month') return false
  if (!userIsPremium || userIsSuper) return false
  return true
}
